import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { useHistory,  } from 'react-router-dom';
import classNames from 'classnames';

import Button, { ButtonLink } from 'components/base/Button';
import Checkbox from 'components/base/Checkbox';
import Dropdown from 'components/base/Dropdown';
import FormControlWraper from 'components/base/FormControlWraper';
import {
  loadContact,
  saveContact,
  selectContact,
  selectContactStatuses,
  selectContactTypes,
  selectLoading
} from 'data/contacts';
import { selectPabEnabled } from 'data/user';
import { UsStateShortOptions } from 'data/user/constants';
// import { useParams } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import dropdownNormalize from 'utils/normalizers/dropdown';
import { cleanPhone, validate, verifyRequired } from 'utils/validation';
import ContactItems from './Items';
import { isRedactedContact } from '../../../utils/contactUtil';

import css from './style.scss';
import Select from '../../../components/Select';
import CheckboxItem from '../../../components/Checkbox';
import SimpleModal from 'components/base/SimpleModal';

const normalizePhone = (phone = '') => (phone || '').replace(/\D/g, '');

const mergePhonesWithAppendedPhones = (phones = [], appendedPhones = []) => {
  if (!Array.isArray(phones)) return [];

  const appendedByPhone = {};

  if (Array.isArray(appendedPhones)) {
    appendedPhones.forEach((ap) => {
      const key = normalizePhone(ap.phone);
      if (!key || appendedByPhone[key]) return;
      appendedByPhone[key] = ap;
    });
  }

  return phones.map((p, seq) => {
    const key = normalizePhone(p.phone);
    const appended = key && appendedByPhone[key];

    const publicDNC = appended ? Boolean(appended.publicDNC) : false;

    return {
      ...p,
      seq,
      publicDNC,
    };
  });
};

const Wrapper = ({ name, label, children }) => (
  <FormControlWraper id={name} label={label} labelClassName={css.selectLabel} className={css.formControlWraper} hasMarginBottom large>
    {children}
  </FormControlWraper>
);

const LabeledTextInput = ({ name, label, contact = {}, onChange, disabled = false, maxLength }) => (
  <Wrapper name={name} label={label}>
    <input
      className={css.input}
      name={name}
      type="text"
      value={contact[name] || ''}
      onChange={onChange}
      disabled={disabled}
      maxLength={maxLength}
    />
  </Wrapper>
);

const LabeledDropdown = ({ name, label, options, onChange, contact = {} }) => (
  <div>
    <div className={css.selectLabel}>{label}</div>
    {/* <Dropdown name={name} options={options} value={contact[name]} onChange={onChange} /> */}
    <Select name={name}
      lists={options}
      selectedValue={contact[name]}
      valueKey="value"
      labelKey="label"
      autoFlip
      onSelect={({ value }) => {
        const event = {
          target: {
            name: name,
            value: value
          }
        };
        onChange(event);
      }}
    />
  </div>
);

const blankState = () => ({
  companyName: null,
  contact: {
    phones: [],
    emails: [],
  },
});

const phoneTypes = [
  { label: 'Mobile', value: 'MOBILE' },
  { label: 'Landline', value: 'LANDLINE' },
  { label: 'Other', value: 'OTHER' },
];

const emailTypes = [
  { label: 'Home', value: 'HOME' },
  { label: 'Work', value: 'WORK' },
  { label: 'Other', value: 'OTHER' },
];

const ContactEditor = ({ location, history }) => {
  const [state, setState] = useState(blankState());
  const [localLoading, setlocalLoading] = useState(false);
  // Decided to keep the page uneditable if the contact is redacted, as that is the only way to know for sure if the contact is redacted or not. This is because the API will return the same response for a redacted contact and a contact that has been edited to have all of the same values as the redacted contact (firstName and lastName of "Redacted Contact"). This is a rare edge case, but it is possible, so we need to be able to handle it.
  const [contactRedacted, setContactRedacted] = useState(false);

  const [isNewContact, setisNewContact] = useState('');
  const [pristine, setPristine] = useState();
  const [isDirty, setIsDirty] = useState(false);

  // State for validation modal
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [validationMessage, setValidationMessage] = useState('');
  const [validationTitle, setValidationTitle] = useState('Required Field Left Blank');


  // const regex = /contact\/(\d+)\/(\d+)/;
  // const matches = location.pathname.match(regex);
  // const groupId = matches && matches.length > 1 ? matches[1] : null;
  // const contactId = matches && matches.length > 2 ? matches[2] : null;

  // const regex = /contact\/(\d+)\/(\d+)/;
  const matches = location.pathname.split("/");
  const groupId = matches && matches.length > 1 ? matches[2] : null;
  const contactId = matches && matches.length > 2 ? matches[3] : null;



  const parentPath = `/contact/${groupId}`;

  const dispatch = useDispatch();

  const types = useSelector(selectContactTypes);
  const statuses = useSelector(selectContactStatuses);
  const loading = useSelector(selectLoading);
  const pabEnabled = useSelector(selectPabEnabled);
  const selectContactload = useSelector(selectContact)

  const handleLoadContact = async () => {
    try {
      await dispatch(
        loadContact(Number(contactId), ({ response }) => {
          const resp = response?.response || {};
          setState({
            companyName: resp.companyName,
            contact: {
              ...resp,
              phones: mergePhonesWithAppendedPhones(resp.phones || [], resp.appendedPhones || []),
              emails: resp.emails?.map((e, seq) => ({ ...e, seq })) || [],
              type: undefined,
              status: undefined,
            },
          });
        }),
      );
    } catch (error) {
      console.error('Failed to load contact:', error);
    }
  };

  useEffect(() => {
    if (contactId && contactId !== 'new') {
      handleLoadContact();
    } else {
      clearContact()
      setlocalLoading(false)
    }
  }, [contactId]);

  const clearContact = () => {
    setState(blankState());
    setIsDirty(false);
  }

  const handleChange = (ev) => {
    if(contactRedacted) return;
    const { name, value, checked } = ev.target || ev;
    setState((prevState) => ({
      contact: { ...prevState.contact, [name]: name === 'mailAddressSame' ? !checked : value },
    }));
    setIsDirty(true);
  };

  const handleCancel = () => {
    history.push(parentPath);
  };

  const hasNoData = () => {
    const { contact } = state;
    return (
      !contact.firstName &&
      !contact.lastName &&
      !contact.companyName &&
      !contact.streetAddress &&
      !contact.city &&
      !contact.state &&
      !contact.zip &&
      (!contact.phones || contact.phones.length === 0) &&
      (!contact.emails || contact.emails.length === 0)
    );
  };

  // Function to check if Contact Type and Status are selected
  const isFormValid = () => {
    const { contact } = state;
    
    // Check if Contact Type is selected
    const hasType = contact.typeId !== undefined && 
                   contact.typeId !== null && 
                   contact.typeId !== '' && 
                   contact.typeId !== 0;
    
    // Check if Contact Status is selected
    const hasStatus = contact.statusId !== undefined && 
                     contact.statusId !== null && 
                     contact.statusId !== '' && 
                     contact.statusId !== 0;
    
    // Return true only if both Contact Type and Status are selected
    return hasType && hasStatus;
  };

  const handleSubmit = (event) => {
    if(contactRedacted) return;
    event.preventDefault();
    const { contact } = state;

     // Check if Contact Type is selected
    if (!contact.typeId || contact.typeId === 0 || contact.typeId === '') {
      setValidationTitle('Required Field Left Blank');
      setValidationMessage('Please select a contact type.');
      setShowValidationModal(true);
      return; // Stop submission, modal will show
    }

    // Check if Contact Status is selected
    if (!contact.statusId || contact.statusId === 0 || contact.statusId === '') {
      setValidationTitle('Required Field Left Blank');
      setValidationMessage('Please select a contact status.');
      setShowValidationModal(true);
      return; // Stop submission, modal will show
    }

    // Check that any entered contact numbers are valid before saving, so an
    // invalid value is rejected instead of silently wiping the existing number.
    const invalidPhone = (contact.phones || []).find((p) => p.phone && p.phone.trim() !== '' && !cleanPhone(p.phone));
    if (invalidPhone) {
      setValidationTitle('Invalid Contact Number');
      setValidationMessage('Please enter a valid contact number.');
      setShowValidationModal(true);
      return; // Stop submission, modal will show
    }

    // Additional validation before submitting
    if (!isFormValid()) {
      return;
    }

    validate(() => {
      verifyRequired(null, `${contact.firstName}${contact.lastName}${contact.companyName}`, 'First Name, Last Name, or Company Name is required.');
      verifyRequired(null, contact.typeId, 'Please select a contact type.');
      verifyRequired(null, contact.statusId, 'Please select a contact status.');

      dispatch(saveContact(contact, () => history.push(parentPath)));
    });
  };

  // Close validation modal
  const closeValidationModal = () => {
    setShowValidationModal(false);
    setValidationMessage('');
  };

  useEffect(() => {
    if (selectContactload && selectContactload?.get('id') && contactId !== 'new') {
      const mapToObj = (map) => Object.fromEntries(map.entries());
      const selectedContact = mapToObj(selectContactload);

      const phones = selectedContact?.phones?.toJS
        ? selectedContact.phones.toJS()
        : selectedContact?.phones || [];
      const emails = selectedContact?.emails?.toJS
        ? selectedContact.emails.toJS()
        : selectedContact?.emails || [];
      const appendedPhones = selectedContact?.appendedPhones?.toJS
        ? selectedContact.appendedPhones.toJS()
        : selectedContact?.appendedPhones || [];

      setContactRedacted(isRedactedContact(selectedContact));
      setState({
        companyName: selectedContact?.companyName,
        contact: {
          ...selectedContact,
          phones: mergePhonesWithAppendedPhones(phones, appendedPhones),
          emails: emails?.map((e, seq) => ({ ...e, seq })) || [],
          type: undefined,
          status: undefined,
        },
      });
      setIsDirty(false);
    }
    else {
      setContactRedacted(false);
    }
  }, [selectContactload]);


  // 
  // const { isNewContact, pristine } = state;
  const { companyName, contact } = state;
  const saveButtonText = (isNewContact || !pristine) ? 'Save' : 'Saved';
  const fieldProps = { contact, onChange: handleChange };
  const { emails, phones } = contact;
  const btn = { isLoading: loading, size: Button.size.large };
  const cancelBtn = { ...btn, };
  const saveBtn = { ...btn, };

  // Determine if save button should be disabled - only based on Contact Type and Status
  const isSaveDisabled = loading || 
                        contactRedacted || 
                        !isFormValid();

  return (
    <>
    <div className={css.newContact}>
      <div className={css.header}>
        <div className={css.left}>
          <div>
            <div className={css.title}>{contact.id ? contact.name || companyName : 'New Contact'} {contact?.litigatorFlag ? '(Litigator)' : ''}</div>
            {!contact.name || !companyName ? null : <div className={css.companyTitle}>{companyName}</div>}
          </div>
        </div>
        <div className={css.legend}>
          {!pabEnabled ? null : <div>(PAB) - Possible Agent or Broker</div>}
        </div>
        <div className={css.right}>
          <button className={css.btnSecondary} {...cancelBtn} to={parentPath} onClick={handleCancel} disabled={loading}>
            Cancel
          </button>
          <button 
            className={css.btnPrimary} 
            {...saveBtn} 
            onClick={handleSubmit} 
            // disabled={isSaveDisabled}
          >
            {saveButtonText}
          </button>
        </div>
      </div>
      <div className={classNames(css.body, { [css.redacted]: contactRedacted })}>
        <div className={css.container}>
          <div className={css.fields}>
            <div className={css.fieldLabel}>Profile</div>
            <div className={css.row}>
              <div className={css.md}>
                <LabeledTextInput name="firstName" label="First Name" maxLength={100} {...fieldProps} />
              </div>
              <div className={css.sm}>
                <LabeledTextInput name="middleName" label="Middle Name" maxLength={100} {...fieldProps} />
              </div>
              <div className={css.md}>
                <LabeledTextInput name="lastName" label="Last Name" maxLength={100} {...fieldProps} />
              </div>
            </div>
            <div className={css.row}>
              <div className={css.lg}>
                <LabeledTextInput name="companyName" label="Company Name" maxLength={200} {...fieldProps} />
              </div>
              <div className={css.md}>
                <LabeledTextInput name="suffix" label="Suffix" maxLength={50} {...fieldProps} />
              </div>
            </div>
            <div className={css.row}>
              <div className={css.lg}>
                <LabeledTextInput name="streetAddress" label="Property Address" maxLength={200} {...fieldProps} />
              </div>
              <div className={css.md}>
                <LabeledTextInput name="city" label="City" maxLength={100} {...fieldProps} />
              </div>
            </div>
            <div className={css.row}>
              <div className={css.lg}>
                <LabeledDropdown name="state" label="State" options={UsStateShortOptions} {...fieldProps} />
              </div>
              <div className={css.md}>
                <LabeledTextInput name="zip" label="Zip" {...fieldProps} />
              </div>
            </div>
            <div className={classNames(css.row, css.checkRow)}>
              <CheckboxItem label="Mailing address is different from Property Address" checked={!contact.mailAddressSame} onChange={handleChange} name="mailAddressSame" labelClassName={css.mailingLabel}/>
            </div>
            {contact.mailAddressSame ? null : (
              <div>
                <div className={css.row}>
                  <div className={css.lg}>
                    <LabeledTextInput name="mailStreetAddress" label="Mailing Address" maxLength={200} {...fieldProps} />
                  </div>
                  <div className={css.md}>
                    <LabeledTextInput name="mailCity" label="City" maxLength={100} {...fieldProps} />
                  </div>
                </div>
                <div className={css.row}>
                  <div className={css.lg}>
                    <LabeledDropdown name="mailState" label="State" options={UsStateShortOptions} {...fieldProps} />
                  </div>
                  <div className={css.md}>
                    <LabeledTextInput name="mailZip" label="Suffix" {...fieldProps} />
                  </div>
                </div>
              </div>
            )}
            <div className={css.row}>
              <div className={css.sm2}>
                <LabeledDropdown name="typeId" label={<>Contact Type<span className={css.requiredAsterisk}>*</span></>} options={dropdownNormalize(types)} {...fieldProps} />
              </div>
              <div className={css.sm2}>
                <LabeledDropdown name="statusId" label={<>Status<span className={css.requiredAsterisk}>*</span></>}  options={dropdownNormalize(statuses)} {...fieldProps} />
              </div>
            </div>
          </div>
          <ContactItems
            items={phones}
            field="phone"
            title="Phone Numbers"
            types={phoneTypes}
            onChange={handleChange}
          />
          <ContactItems items={emails} field="email" title="Email Addresses" types={emailTypes} onChange={handleChange} />
        </div>
      </div>
    </div>
     {showValidationModal && (
      <SimpleModal
        isOpen={showValidationModal}
        title={validationTitle}
        description={validationMessage}
        modalClassName={css.validationModal}
        cancelText="OK"
        onCancel={closeValidationModal}
        onCancelRedirect={closeValidationModal}
        uniqueId={`validation-modal-${new Date().getTime()}`}
      /> )}
    </>
    );
};

ContactEditor.defaultProps = {
  title: 'New Contact',
};

export default withRouter(ContactEditor);
